const DEVICE_ID_PATTERN = /^[a-zA-Z0-9_-]{16,64}$/;

class DeviceCommon {
  getDeviceId = () => {
    let id = localStorage.getItem('deviceId');
    if (!id || !DEVICE_ID_PATTERN.test(id)) {
      id = crypto.randomUUID();
      localStorage.setItem('deviceId', id);
    }
    return id;
  };
}

const deviceCommon = new DeviceCommon();

export default deviceCommon;
